import { lazy } from "react"

// GeneralError is the fallback screen for every error path (including chunk-load
// failures), so it must ship in the main bundle rather than a lazy chunk.
// A lazy chunk that loads slowly or fails to fetch would strand users on the
// bare Suspense spinner — a persistent blank white screen.
export { GeneralErrorScreen } from "../screens/ErrorScreens/GeneralError"

export const OnboardingV2Router = lazy(() =>
  import("../screens/onboarding-flow-v2/Router").then((m) => ({ default: m.OnboardingV2Router }))
)

export const CharityFlowRouter = lazy(() =>
  import("../screens/charity-flow-v2/Router").then((m) => ({ default: m.CharityFlowRouter }))
)

export const LogInRouter = lazy(() =>
  import("../screens/log-in-screens/Router").then((m) => ({ default: m.LogInRouter }))
)

export const PlaidAuthLinkFlowRouter = lazy(() =>
  import("../screens/PlaidAuthLinkFlow/Router").then((m) => ({
    default: m.PlaidAuthLinkFlowRouter,
  }))
)

export const DebitAuthPaymentScreen = lazy(() =>
  import("../screens/DebitAuthPaymentScreen").then((m) => ({
    default: m.DebitAuthPaymentScreen,
  }))
)

export const BankConnectionErrorScreenV2 = lazy(() =>
  import("../screens/ErrorScreens/BankConnectionErrorV2").then((m) => ({
    default: m.BankConnectionErrorScreenV2,
  }))
)
